import 'css-chunksrc/client/scenes/zoneRemoval/styles.scss';export default {
  "header": "_header_1l7oc_1",
  "message": "_message_1l7oc_5",
  "name": "_name_1l7oc_10",
  "main": "_main_1l7oc_14",
  "buttons": "_buttons_1l7oc_21"
};